export const DOCUMENTS_API_VERSION = '2025-08-15'
